// Make youtube embeds responsive and fixed ratio

import { reframe } from '../helpers';

const init = () => {
	const youtubeEmbeds = document.querySelectorAll('.wp-block-embed-youtube iframe');

	if (!youtubeEmbeds) {
		return;
	}

	reframe(document.querySelectorAll('.wp-block-embed-youtube iframe'));
};

init();
